import KofiErfassungModulBaseMixin from "./KofiErfassungModulBaseMixin";

// @vue/component
export default {
  name: "KofiErfassungModul",
  mixins: [
    KofiErfassungModulBaseMixin,
  ],
};
